import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { CalculateJobETARequest } from '../../domain';
import { JobsRepository } from '../../repositories';


@Injectable({ providedIn: 'root' })
export class CalculateJobETAUsecase implements UseCase<CalculateJobETARequest,boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: CalculateJobETARequest): Observable<boolean> {
    return this.jobRepository.calculateJobETA(params);
  }

}
